import { jsonToFormData } from 'src/common/helpers/json-to-form-data';
import { API_ENDPOINTS } from 'src/setup/client/api-endpoints';
import HttpClient from 'src/setup/client/http-client';
import {
    MarginTransferable,
    NotificationsRequestDTO,
    TransferBalance,
    WalletTransferable,
    MarkNotificationAsReadRequestDTO,
} from 'src/types';
import { SetSettingsRequestDTO } from 'src/types/commonConfig';

// API calls for fetching server data
export function fetchIndexConfig() {
    return HttpClient.get(API_ENDPOINTS.INDEX_CONFIG);
}

export function fetchConfigV2(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.CONFIG_V2}?${queryParams}`, {
        headers: {
            Accept: '*', // TODO:: Remove custom header when API response fixed from backend
        },
    });
}

export function fetchTokenRates(payload: object) {
    return HttpClient.post(API_ENDPOINTS.TOKEN_RATES, payload);
}

// API calls to fetch sub accounts
export function fetchWalletSubAccounts() {
    return HttpClient.get(`${API_ENDPOINTS.WALLETS_SUB_ACCOUNTS}`);
}

// API calls to fetch sub account transfer available
export function fetchTransferAvailable(body: WalletTransferable) {
    return HttpClient.post(`${API_ENDPOINTS.TRANSFER_AVAILABLE}`, body);
}

// API calls to fetch sub account type margin available
export function fetchTransferAvailableMargin(body: MarginTransferable) {
    return HttpClient.post(`${API_ENDPOINTS.MARGIN_TRANSFER_AVAILABLE}`, body);
}

// API calls to transfer wallet balance
export function transferWalletBalance(body: TransferBalance) {
    return HttpClient.post(`${API_ENDPOINTS.TRANSFER_BALANCE}`, body);
}

// API calls to fetch coin tokens
export function fetchCoinTokens() {
    return HttpClient.get(`${API_ENDPOINTS.WALLET_COIN_TOKENS}`);
}

// API calls to fetch server time
export function getServerTime() {
    return HttpClient.get(`${API_ENDPOINTS.SERVER_TIME}`);
}

// API calls to fetch kline history
export function klineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.KLINE_HISTORY}?${queryParams}`);
}
// API calls to fetch index kline history
export function indexKlineHistory(queryParams: string) {
    return HttpClient.get(`${API_ENDPOINTS.INDEX_KLINE_HISTORY}?${queryParams}`);
}

export function getSettings() {
    return HttpClient.get(API_ENDPOINTS.GET_SETTINGS);
}

export function setSettings(data: SetSettingsRequestDTO) {
    const formDataBody = jsonToFormData(data);
    return HttpClient.post(API_ENDPOINTS.SET_SETTINGS, formDataBody);
}

export function getNotifications(data: NotificationsRequestDTO) {
    const formDataBody = jsonToFormData(data);
    return HttpClient.post(API_ENDPOINTS.GET_NOTIFICATIONS, formDataBody);
}

export function getPopupNotifications() {
    return HttpClient.post(API_ENDPOINTS.GET_POPUP_NOTIFICATIONS, {});
}

export function markNotificationAsRead(data: MarkNotificationAsReadRequestDTO) {
    const formDataBody = jsonToFormData(data);
    return HttpClient.post(API_ENDPOINTS.MARK_NOTIFICATION_AS_READ, formDataBody);
}
